import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { getBranches } from '../services/api';
import { canAccessAllBranches } from '../utils/auth';
import { cacheBranchesForPrint } from '../utils/branchPrint';

const BranchContext = createContext({
  branches: [],
  selectedBranchId: '',
  selectedBranch: null,
  setSelectedBranchId: () => {},
  reloadBranches: () => {}
});

export const useBranchFilter = () => useContext(BranchContext);

export const BranchProvider = ({ children }) => {
  const [branches, setBranches] = useState([]);
  const [selectedBranchId, setSelectedBranchIdState] = useState(
    () => localStorage.getItem('erp_admin_branch_filter') || ''
  );

  const reloadBranches = useCallback(async () => {
    if (!canAccessAllBranches()) return;
    try {
      const res = await getBranches();
      const list = res.data || [];
      setBranches(list);
      cacheBranchesForPrint(list);
    } catch (err) {
      console.error('Failed to load branches', err);
    }
  }, []);

  useEffect(() => {
    reloadBranches();
  }, [reloadBranches]);

  const setSelectedBranchId = (id) => {
    setSelectedBranchIdState(id);
    if (id) localStorage.setItem('erp_admin_branch_filter', String(id));
    else localStorage.removeItem('erp_admin_branch_filter');
    window.dispatchEvent(new Event('branch-filter-changed'));
  };

  const selectedBranch = branches.find((b) => String(b.id) === String(selectedBranchId)) || null;

  return (
    <BranchContext.Provider value={{ branches, selectedBranchId, selectedBranch, setSelectedBranchId, reloadBranches }}>
      {children}
    </BranchContext.Provider>
  );
};

export default BranchContext;
